import {
    FETCH_PLAN_MERCHANTS_LOADING,
    FETCH_PLAN_MERCHANTS_SUCCESS,
    FETCH_PLAN_MERCHANTS_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    data: null,
    error: null,
  };
  
  const planMerchantsReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case FETCH_PLAN_MERCHANTS_LOADING:
        return { ...state, loading: true, error: null };
  
      case FETCH_PLAN_MERCHANTS_SUCCESS:
        return { ...state, loading: false, data: action.payload };
  
      case FETCH_PLAN_MERCHANTS_FAILED:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default planMerchantsReducer;
  